export const staticBaseUrl = window.feConfig.common.staticBaseUrl;
export const GWNL_MEDIA_DOMAIN = staticBaseUrl + 'ufd/c4d5f9/gwnl/pc/';
